/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef } from 'react';

// Components
import { InputRadio } from '../../atoms/InputRadio/InputRadio';
// Styles
import styles from './InputsRadioGroup.module.css';

/**
 * `InputsRadioGroup` group of radio inputs.
 *
 * @typedef {Object} Props The properties for the `TextField` component.
 * @property {string} name The name of the text field, used for identification.
 * @property {Array<Object>} [options=[]] The available options.
 * @property {string} [label] The label associated with the text field.
 * @property {string} [error] The error message to display below the field if an error exists.
 * @property {string} [className] Additional CSS classes to apply to the component.
 * @property {string} [defaultValue] The default value to display on init.
 * @property {boolean} [disabled=false] If `true`, the field will be disabled.
 * @property {import("react").MouseEventHandler<HTMLInputElement>} [onClick=()=>{}] onClick event.
 * @property {import('react').ComponentPropsWithoutRef<any>} [props.props]
 */

/**
 * @type React.ForwardRefExoticComponent<Props>
 */
export const InputsRadioGroup = forwardRef(
  ({
    name,
    options,
    label,
    error,
    className,
    defaultValue,
    onClick,
    ...props
  }, ref) => (
    <div className={className}>
      {label ? <span className={styles.label}>{label}</span> : null}

      <div className={styles.group}>
        {options.map(({ value: optionValue, label: optionLabel }) => (
          <InputRadio
            // @ts-ignore
            ref={ref}
            key={optionValue}
            id={`${name}_${optionValue}`}
            name={name}
            value={optionValue}
            label={optionLabel}
            defaultChecked={optionValue === defaultValue}
            onClick={onClick}
            {...props}
          />
        ))}
      </div>

      {error ? (
        <span id={name ? `error-${name}` : ''} className={styles.error}>
          {error}
        </span>
      ) : null}
    </div>
  ),
);

export default InputsRadioGroup;
